import React, { useEffect, useState } from 'react';
import { Carousel, Col, Container, Dropdown, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import ActionMenu from '../../components/ActionMenu/ActionMenu';
import ActionMenuItem from '../../components/ActionMenu/ActionMenuItem';
import Authorize from '../../components/AuthComponent/Authorize';
import Button from '../../components/Buttons/Button';
import IconButton from '../../components/Buttons/IconButton';
import SaveButton from '../../components/Buttons/SaveButton';
import ButtonBar from '../../components/Fields/ButtonBar';
import DateControl from '../../components/Fields/DateControl';
import Field from '../../components/Fields/Field';
import FieldLabel from '../../components/Fields/FieldLabel';
import SelectListField from '../../components/Fields/SelectListField';
import TextareaControl from '../../components/Fields/TextareaControl';
import TextareaField from '../../components/Fields/TextareaField';
import TextboxField from '../../components/Fields/TextboxField';
import { FieldConfig, FormConfig, SelectListOption, ValidatorConfig } from '../../components/Fields/Types';
import Form from '../../components/Form/Form';
import Title from '../../components/Headers/Title';
import useSelectListOptions from '../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import SpinnerOverlay from "../../components/Spinner/SpinnerOverlay";
import { HorizontalTabs } from '../../components/Tabs/HorizontalTabs';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import { useTranslations } from '../../contexts/translationContext';
import AssociationTypes from '../../enums/AssociationTypes';
import CommentModel from '../../models/CommentModel';
import ItemRevisionColorModel from '../../models/ItemRevisionColorModel';
import ItemRevisionModel from '../../models/ItemRevisionModel';
import ItemSizeModel from '../../models/ItemSizeModel';
import DataService from '../../services/data.service';
import IdParams from '../../types/IdParams';
import { DataResult, Result } from '../../types/Result';
import Unauthorized from '../Authentication/Unauthorized';
import CommentView from './Components/Comment';
import ItemColorField from './Components/ItemColorField';
import ItemRevisionSizeField from './Components/ItemRevisionSizeField';
import ItemRevision_popup_ChangeItemNr from './Popups/ItemRevision_popup_ChangeItemNr';
import ItemRevision_popup_ChangeReferenceCodes from './Popups/ItemRevision_popup_ChangeReferenceCodes';
import ItemRevision_popup_CreateBillOfMaterials from './Popups/ItemRevision_popup_CreateBillOfMaterials';
import ItemRevision_popup_CreateNewItemRevisionPopup from './Popups/ItemRevision_popup_CreateNewItemRevision';
import ItemRevision_popup_DeleteItem from './Popups/ItemRevision_popup_DeleteItem';
import ItemRevision_popup_DuplicateItemRevisionPopup from './Popups/ItemRevision_popup_DuplicateItemRevision';
import ItemRevision_popup_EditColors from './Popups/ItemRevision_popup_EditColors';
import ItemRevision_popup_EditItemSizes from './Popups/ItemRevision_popup_EditItemSizes';
import ItemRevision_popup_ExportItem from './Popups/ItemRevision_popup_ExportItem';
import ItemRevision_popup_GenerateAttachmentPopup from './Popups/ItemRevision_popup_GenerateAttachment';
import ItemRevision_popup_ItemColors from './Popups/ItemRevision_popup_ItemColors';
import ItemRevision_popup_ItemFollowers from './Popups/ItemRevision_popup_ItemFollowers';
import ItemRevision_popup_ItemSizes from './Popups/ItemRevision_popup_ItemSizes';
import ItemRevision_popup_ItemSizeSets from './Popups/ItemRevision_popup_ItemSizeSets';
import ItemRevision_popup_StartWorkflowPopup from './Popups/ItemRevision_popup_StartWorkflow';
import ItemRevision_popup_UsedInItemsPopup from './Popups/ItemRevision_popup_UsedInItems';
import ItemRevision_tab_Attachments from './Tabs/ItemRevision_tab_Attachments';
import ItemRevision_tab_BillOfMaterials from './Tabs/ItemRevision_tab_BillOfMaterials';
import ItemRevision_tab_Brands from './Tabs/ItemRevision_tab_Brands';
import ItemRevision_tab_BusinessPartners from './Tabs/ItemRevision_tab_BusinessPartners';
import ItemRevision_tab_Employees from './Tabs/ItemRevision_tab_Employees';
import ItemRevision_tab_History from './Tabs/ItemRevision_tab_History';
import ItemRevision_tab_Licenses from './Tabs/ItemRevision_tab_Licenses';
import ItemRevision_tab_Milestones from './Tabs/ItemRevision_tab_Milestones';
import ItemRevision_tab_Prices from './Tabs/ItemRevision_tab_Prices';
import ItemRevision_tab_ProductCategories from './Tabs/ItemRevision_tab_ProductCategories';
import ItemRevision_tab_Projects from './Tabs/ItemRevision_tab_Projects';
import ItemRevision_tab_Revisions from './Tabs/ItemRevision_tab_Revisions';
import ItemRevision_tab_SubItems from './Tabs/ItemRevision_tab_SubItems';
import ItemRevision_tab_UserDefinedFields from './Tabs/ItemRevision_tab_UserDefinedFields';
import ItemRevision_tab_Workflows from './Tabs/ItemRevision_tab_Workflows';

const ItemRevisionView: React.FC = () => {
    const [itemRevisionId, setItemRevisionId] = useState<number>()
    const [serverErrors, setServerErrors] = useState<DataResult<ItemRevisionModel>>({ isSuccesful: true, messages: [], data: undefined });
    const [productCategories, setProductCategories] = useState<SelectListOption[]>([]);
    const { handleResult, handleException } = useNotifications();
    const { translate } = useTranslations();
    const [formData, setFormData] = useState<ItemRevisionModel>();
    const [brandId, setBrandId] = useState<number>();
    const [productCategoryId, setProductCategoryId] = useState<number>();
    const [showSpinner, setShowSpinner] = useState(true);
    const [refreshNr, setRefreshNr] = useState(0);
    const [bomRefreshCounter, setBomRefreshCounter] = useState(0);
    const [customerSkuEditable, setCustomerSkuEditable] = useState(false)
    const [licensorSkuEditable, setLicensorSkuEditable] = useState(false)
    const [showChangeItemNrPopup, setShowChangeItemNrPopup] = useState<boolean>(false);
    const [showChangeReferenceCodesPopup, setShowChangeReferenceCodesPopup] = useState<boolean>(false);
    const [showCreateNewItemRevisionPopup, setShowCreateNewItemRevisionPopup] = useState<boolean>(false);
    const [showCreateNewBomPopup, setShowCreateNewBomPopup] = useState<boolean>(false);
    const [showDeletePopup, setShowDeletePopup] = useState<boolean>(false);
    const [showDuplicateItemRevisionPopup, setShowDuplicateItemRevisionPopup] = useState<boolean>(false);
    const [showGenerateAttachmentPopup, setShowGenerateAttachmentPopup] = useState<boolean>(false);
    const [showStartWorkflowPopup, setShowStartWorkflowPopup] = useState<boolean>(false);
    const [showUsedInItemsPopup, setShowUsedInItemsPopup] = useState<boolean>(false);
    const [showItemFollowersPopup, setShowItemFollowersPopup] = useState<boolean>(false);
    const [showExportPopup, setShowExportPopup] = useState<boolean>(false);
    const [showItemSizesPopup, setShowItemSizesPopup] = useState<boolean>(false);
    const [showItemSizeSetsPopup, setShowItemSizeSetsPopup] = useState<boolean>(false);
    const [showItemColorsPopup, setShowItemColorsPopup] = useState<boolean>(false);
    const [showEditColorsPopup, setShowEditColorsPopup] = useState(false)
    const [showEditSizesPopup, setShowEditSizesPopup] = useState(false)
    const [isAuthorized, setIsAuthorized] = useState<boolean>(true);
    const [comments, setComments] = useState<string>('')
    const { user } = useAuth()
    const navigate = useNavigate();

    const brands = useSelectListOptions('api/v1/selectlist/BrandNameTreeLeaves?activeOnly=true&brandId=' + brandId, '-- Select brand');
    const divisions = useSelectListOptions('api/v1/selectlist/Divisions?activeOnly=true', '-- Select division');

    let idParams: IdParams = useParams();
    if (idParams.id && !Number.isNaN(parseInt(idParams.id))) {
        if (itemRevisionId != parseInt(idParams.id)) {
            setItemRevisionId(parseInt(idParams.id));
        }
    }

    let itemId: number | undefined;
    if (formData) {
        itemId = formData.itemId;
    }

    useEffect(() => {
        setFormData(undefined)
        loadFormData();
    }, [itemRevisionId]);

    function loadFormData() {
        if (itemRevisionId !== undefined) {
            setShowSpinner(true);
            DataService.getById<ItemRevisionModel>('api/v1/itemrevisions/', itemRevisionId)
                .then(response => {
                    setShowSpinner(false);
                    setFormData(x => ({ ...response }));
                    setBrandId(response.brandId)
                    setProductCategoryId(response.productCategoryId)
                    setLicensorSkuEditable(response.item.licensorSKU != '' && response.item.licensorSKU != null)
                    setCustomerSkuEditable(response.item.customerSKU != '' && response.item.customerSKU != null)
                    setRefreshNr(x => x + 1);
                })
                .catch(e => {
                    setShowSpinner(false);
                    if (e.response?.data?.status === 401)
                        setIsAuthorized(false);
                    else
                        handleException(e);
                });
        }
    }

    function loadComments() {
        if (formData && itemRevisionId !== undefined) {
            setShowSpinner(true);
            DataService.get<CommentModel[]>('api/v1/comments/ByItemRevision/' + itemRevisionId)
                .then(response => {
                    setShowSpinner(false);
                    formData.comments = response
                    setFormData(x => ({ ...formData }));
                })
                .catch(e => { setShowSpinner(false); handleException(e); });
        }
    }


    useEffect(() => {
        if (formData)
            translate('-- Select category').then(translated => {
                DataService.get<SelectListOption[]>(`api/v1/selectlist/ProductCategoryNameTreeLeaves?productCategoryId=${productCategoryId}&itemTypeId=${formData.item.itemTypeId}&nullOption=${translated}`)
                    .then(response => setProductCategories(response))
                    .catch(e => handleException(e));
            });
    }, [formData, translate, productCategoryId]);

    function navigateTo(itemRevisionId) {
        if (itemRevisionId) {
            const url = '/plm/Items/ItemRevision/' + itemRevisionId;
            navigate(url);
        }
    }

    function submit() {
        setShowSpinner(true);
        if (formData) {
            DataService
                .update<ItemRevisionModel>(`api/v1/itemrevisions/`, formData)
                .then(response => {
                    setShowSpinner(false);
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && response.data) {
                        const responseData = response.data;
                        setFormData(x => ({ ...responseData }));
                        setRefreshNr(x => x + 1);
                    }
                })
                .catch(e => {
                    setShowSpinner(false);
                    handleException(e);
                });
        }
    }

    function submitComments() {
        setShowSpinner(true);
        if (formData && comments != '') {
            const data = {
                discussionId: formData.item.discussionId,
                itemId: formData.itemId,
                text: comments,
            };
            DataService
                .create<Result>(`api/v1/comments/`, data)
                .then(response => {
                    setShowSpinner(false);
                    handleResult(response);
                    if (response.isSuccesful) {
                        setComments('')
                        loadComments()
                    }
                })
                .catch(e => {
                    setShowSpinner(false);
                    handleException(e);
                });
        }
    }

    function addColors(itemRevisionColors?: ItemRevisionColorModel[]) {
        if (formData && itemRevisionColors) {
            //formData.colors = formData.colors.concat(itemRevisionColors)
            //setFormData({ ...formData })
            refreshColors()
            setShowEditColorsPopup(true)
        }
    }
    function updateColors(itemRevisionColors?: ItemRevisionColorModel[]) {
        if (formData && itemRevisionColors) {
            formData.colors = [...itemRevisionColors]
            setFormData({...formData})
            refreshColors()
        }
    }
    function removeColor(itemRevisionColorId: Number) {
        if (formData) {
            var itemRevisionColor = formData.colors.filter(x => x.id == itemRevisionColorId)[0]
            var index = formData.colors.indexOf(itemRevisionColor)
            formData.colors.splice(index, 1);
            setFormData({ ...formData })

            if (formData.item.parentItemId)
                navigate('/plm/home')
            else
                refreshColors()
        }
    }

    function refreshColors() {
        if (formData)
            DataService
                .get<ItemRevisionColorModel[]>('api/v1/ItemRevisionColors/ByItemRevision/' + formData.id)
                .then(response => {
                    formData.colors = response
                    setFormData({ ...formData })
                    setRefreshNr(x => x + 1);
                })
                .catch(e => handleException(e))
    }

    function onCopyItemNrClick()
    {
        if (formData)
            navigator.clipboard.writeText(formData.item.itemNr);
    }

    function onCopyParentItemNrClick() {
        if (formData)
            navigator.clipboard.writeText(formData.item.parentItem.itemNr);
    }


    function onItemColorClick(itemRevisionColor: ItemRevisionColorModel)
    {
        setShowEditColorsPopup(true)
    }

    function addSizes(itemSizes?: ItemSizeModel[]) {
        if (formData && itemSizes) {
            formData.itemSizes = formData.itemSizes.concat(itemSizes)
            setFormData({ ...formData })
        }
    }
    function updateSizes(updatedItemSizes?: ItemSizeModel[]) {
        if (formData && updatedItemSizes) {
            formData.itemSizes = [...updatedItemSizes]
            setFormData({ ...formData })
        }
    }
    function removeSize(itemSizeId: number) {
        if (formData) {
            var itemSize = formData.itemSizes.filter(x => x.id == itemSizeId)[0]
            var index = formData.itemSizes.indexOf(itemSize)
            formData.itemSizes.splice(index, 1);
            setFormData({ ...formData })
            /*
            var index = formData.itemSizes.indexOf(itemSize)
            formData.itemSizes.splice(index, 1);
            setFormData({ ...formData })
            */
        }
    }

    function setAsBomDefault() {
        if (formData) {
            DataService
                .post<Result>(`api/v1/itemrevisions/SetAsBillOfMaterialsDefault`, { itemId: formData.itemId })
                .then(response => {
                    handleResult(response);
                    if (response.isSuccesful === true) {
                        formData.item.isDefaultBillOfMaterialItem = true;
                        setFormData(x => ({ ...formData }));
                    }
                })
                .catch(e => handleException(e));
        }
    }

    let showCategory = true
    let showCategoryTab = false
    let categoryValidators: ValidatorConfig[] = []
    let showBrand = true
    let showBrandTab = false
    let brandValidators: ValidatorConfig[] = []
    if (formData) {
        if (formData.item.itemType.productCategoryAssociationTypeId == AssociationTypes.NoAssociation)
            showCategory = false;
        if (formData.item.itemType.productCategoryAssociationTypeId == AssociationTypes.RequiredSingleAssociation || formData.item.itemType.productCategoryAssociationTypeId == AssociationTypes.MinimumOneRequiredAssociation)
            categoryValidators.push({ type: 'isRequired' });
        if (formData.item.itemType.productCategoryAssociationTypeId == AssociationTypes.MultipleAssociations || formData.item.itemType.productCategoryAssociationTypeId == AssociationTypes.MinimumOneRequiredAssociation)
            showCategoryTab = true;

        if (formData.item.itemType.brandAssociationTypeId == AssociationTypes.NoAssociation)
            showBrand = false;
        if (formData.item.itemType.brandAssociationTypeId == AssociationTypes.RequiredSingleAssociation || formData.item.itemType.brandAssociationTypeId == AssociationTypes.MinimumOneRequiredAssociation)
            brandValidators.push({ type: 'isRequired' });
        if (formData.item.itemType.brandAssociationTypeId == AssociationTypes.MultipleAssociations || formData.item.itemType.brandAssociationTypeId == AssociationTypes.MinimumOneRequiredAssociation)
            showBrandTab = true;
    }

    let fields: FieldConfig[] = [
        { name: 'item.itemType.name', label: 'Item type', labelSize: 2 },
        { name: 'item.name', label: 'Name', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
        { name: 'item.parentItem.itemNr', label: 'Parent item', labelSize: 2 },
        { name: 'productCategoryId', label: 'Category', labelSize: 2, validationRules: categoryValidators },
        { name: 'brandId', label: 'Brand', labelSize: 2, validationRules: brandValidators },
        { name: 'item.description', label: 'Description', labelSize: 2 },
        { name: 'beginDate', label: 'Active from', labelSize: 2, validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
        { name: 'endDate', label: 'Until', labelSize: 'auto', validationRules: [{ type: 'isDate' }] },
        { name: 'item.divisionId', label: 'Division', labelSize: 4, validationRules: [{ type: 'isRequired' }] },
        { name: 'item.divisionName', label: 'Division', labelSize: 4 },
        { name: 'item.customerSKU', label: 'Customer SKU', labelSize: 4 },
        { name: 'item.licensorSKU', label: 'Licensor SKU', labelSize: 4 },
        { name: 'revisionNumber', label: 'Revision', labelSize: 4 },
        { name: 'defaultBomId', label: 'Version', labelSize: 4 },
        { name: 'designPhase', label: 'Design phase', labelSize: 4 },
    ];

    if (formData && formData.itemRevisionStatuses) {
        formData.itemRevisionStatuses.forEach((value, index) => {
            let label = ''
            if (value.itemStatus.itemStatusType != undefined) {
                label = value.itemStatus.itemStatusType.name;
            }
            fields.push({ name: 'itemRevisionStatuses.' + index + '.itemStatus.name', label: label, labelSize: 4 });
        });
    }

    const formConfig: FormConfig = {
        fields: fields,
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getLabelProps, getControlProps, getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    if (!isAuthorized)
        return (<Unauthorized />);

    if (!formData)
        return <SpinnerOverlay />

    return (
        <div className='main-content'>
            <Form>
                <Form.Header
                    title={{ format: '{0}', args: [formData.item.itemNr + ' - v' + formData.revisionNumber + (formData.itemStatus ? ', ' + formData.itemStatus.name : '')] }}
                    headerElement={<>&nbsp;<i className={'fa fa-clipboard'} onClick={onCopyItemNrClick} /></>}
                >
                    <ActionMenu title="Actions">
                        {formData.item.itemType.hasWorkflows && <ActionMenuItem icon="fa fa-cogs" title="Start a workflow" appFunction={ApplicationFunctions.StartItemWorkflow} workflowDefinitionId={0} onClick={() => { setShowStartWorkflowPopup(true); }} />}
                        <ActionMenuItem width={220} icon="fa fa-magic" title="Generate a document" appFunction={ApplicationFunctions.CreateAttachment} attachmentTypeId={0} onClick={() => { setShowGenerateAttachmentPopup(true); }} />
                        <Dropdown.Divider />
                        <ActionMenuItem icon="fa fa-plus" iconVariant="success" title="New version" appFunction={ApplicationFunctions.CreateItemRevision} itemTypeId={formData.item.itemTypeId} onClick={() => { setShowCreateNewItemRevisionPopup(true); }} />
                        <ActionMenuItem icon="fa fa-plus" iconVariant="success" title="New BOM for supplier" appFunction={ApplicationFunctions.CreateBillOfMaterial} itemTypeId={formData.item.itemTypeId} onClick={() => { setShowCreateNewBomPopup(true); }} />
                        <ActionMenuItem icon="fa fa-clone" title="Duplicate item revision" appFunction={ApplicationFunctions.CloneItem} itemTypeId={formData.item.itemTypeId} onClick={() => { setShowDuplicateItemRevisionPopup(true); }} />
                        <Dropdown.Divider />
                        <ActionMenuItem icon="fa fa-pencil" title="Change ItemNr" appFunction={ApplicationFunctions.ChangeItemNr} itemTypeId={formData.item.itemTypeId} onClick={() => { setShowChangeItemNrPopup(true); }} />
                        {/*<ActionMenuItem icon="fa fa-pencil" title="Change reference codes" appFunction={ApplicationFunctions.ChangeItemNr} itemTypeId={formData.item.itemTypeId} onClick={() => { setShowChangeReferenceCodesPopup(true); }} />*/}
                        {formData.item.itemType.exportable == true && <ActionMenuItem icon="fa fa-sign-out" title="Export item" appFunction={ApplicationFunctions.ExportItem} itemTypeId={formData.item.itemTypeId} onClick={() => { setShowExportPopup(true); }} />}
                        {/*formData.item.itemType.hasSizes == true && <ActionMenuItem icon="fa fa-list" title="Sizesets" onClick={() => { setShowItemSizeSetsPopup(true); }} />}
                        {formData.item.itemType.hasSizes == true && <ActionMenuItem icon="fa fa-list" title="Sizes" onClick={() => { setShowItemSizesPopup(true); }} />}
                        {formData.item.itemType.hasColors == true && <ActionMenuItem icon="fa fa-list" title="Colors" onClick={() => { setShowItemColorsPopup(true); }} />*/}
                        <Dropdown.Divider />
                        <ActionMenuItem icon="pe-7s-share" title="Used in items" onClick={() => { setShowUsedInItemsPopup(true); }} />
                        <ActionMenuItem icon="fa fa-eye" title="Item followers" appFunction={ApplicationFunctions.ViewItemFollower} itemTypeId={formData.item.itemTypeId} onClick={() => { setShowItemFollowersPopup(true); }} />
                        {formData.item.isDefaultBillOfMaterialItem == false && <ActionMenuItem disabled icon="fa fa-check" title="Set as BOM-default" appFunction={ApplicationFunctions.UpdateItemRevision} itemTypeId={formData.item.itemTypeId} onClick={() => { setAsBomDefault(); }} />}
                        <Dropdown.Divider />
                        <ActionMenuItem icon="fa fa-trash" iconVariant="danger" title="Delete item revision" appFunction={ApplicationFunctions.DeleteItem} itemTypeId={formData.item.itemTypeId} onClick={() => { setShowDeletePopup(true); }} />
                    </ActionMenu>
                </Form.Header>
                <Form.Content>
                    <Container fluid>
                        <Row>
                            <Col md='3'>
                                {formData && formData.images &&
                                    <Carousel>
                                        {formData.images.map((image, index) =>
                                            <Carousel.Item key={index}>
                                                <img src={image.url} alt={image.alt} style={{ width: '100%' }} key={index} />
                                                <Carousel.Caption>
                                                    <p>{image.title}</p>
                                                </Carousel.Caption>
                                            </Carousel.Item>
                                        )}
                                    </Carousel>
                                }
                            </Col>
                            <Col md='6'>
                                <TextboxField {...getFieldProps('item.itemType.name')} disabled />
                                {formData.item.parentItemId != null && <TextboxField {...getFieldProps('item.parentItem.itemNr')} disabled additionalElement={<IconButton icon='fa-clipboard' onClick={onCopyParentItemNrClick} />} />}
                                <TextboxField {...getFieldProps('item.name')} />
                                {showCategory && <SelectListField {...getFieldProps('productCategoryId')} options={productCategories} />}
                                {showBrand && <SelectListField {...getFieldProps('brandId')} options={brands} />}
                                <TextareaField {...getFieldProps('item.description')} rows={10} cols={50} />
                                <Field {...getLabelProps('beginDate')}>
                                    <DateControl {...getControlProps('beginDate')} />
                                    <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('endDate')} /></span>
                                    <DateControl {...getControlProps('endDate')} />
                                </Field>
                                {formData.item.itemType.hasColors && <ItemColorField itemColors={formData.colors} onAdd={addColors} onItemColorClick={onItemColorClick} itemRevisionId={formData.id} showAddButton={formData.item.parentItemId === null} />}
                                {formData.item.itemType.hasSizes && <ItemRevisionSizeField itemSizes={formData.itemSizes} onAdd={addSizes} onShowEditPopup={() => setShowEditSizesPopup(true)} itemId={formData.itemId} itemRevisionId={formData.id} />}
                            </Col>
                            <Col md='3'>
                                <SelectListField {...getFieldProps('item.divisionId')} options={divisions} />
                                {formData.item.itemType.hasCustomerSKU && < TextboxField {...getFieldProps('item.customerSKU')} disabled={customerSkuEditable} />}
                                {formData.item.itemType.hasLicensorSKU && < TextboxField {...getFieldProps('item.licensorSKU')} disabled={licensorSkuEditable} />}
                                <TextboxField {...getFieldProps('revisionNumber')} disabled />
                                {formData && formData.item.itemType.hasDesignPhases == true && <TextboxField {...getFieldProps('designPhase')} disabled />}
                                {formData && formData.itemRevisionStatuses &&
                                    formData.itemRevisionStatuses.map((value, index) => {
                                        let name = 'itemRevisionStatuses.' + index + '.itemStatus.name';
                                        return (<TextboxField {...getFieldProps(name)} key={'itemStatus' + index} disabled />);
                                    })
                                }
                                <Title text='Comments' size={4} />
                                <div>
                                    <div style={{ border: '1px solid #e3e3e3', borderRadius: 10, marginBottom:3 }}>
                                        <div style={{ backgroundColor: '#e3e3e3', borderTopLeftRadius: 10, borderTopRightRadius: 10, height: 40, borderBottomColor: 'black' }} >
                                            <div className='user' style={{ padding: 5 }}><div className='thumbnail' style={{}}><img height='32' src={user?.thumbnailUrl} /></div></div>
                                            <div className='pull-left' style={{paddingLeft:5}}>{user?.name}</div>
                                        </div>
                                        <div style={{ margin: 5 }}>
                                            <TextareaControl name='comments' value={comments} onChange={(value) => setComments(value)} validationResults={[]} />
                                        </div>
                                    </div>
                                    <div>
                                        <Button type='button' text='Submit' onClick={() => submitComments()}></Button>
                                    </div>
                                </div>
                                <div style={{ marginTop:12 }}>
                                    {formData && formData.comments &&
                                        formData.comments.map((value, index) => {
                                            return <CommentView comment={value} key={index} />
                                        })
                                    }
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Form.Content>
                <Form.Footer>
                    <Row>
                        <Col md='3' className='hidden-md'>
                            <ButtonBar offset={0}>
                            </ButtonBar>
                        </Col>
                        <Col md='6'>
                            <ButtonBar offset={2}>
                                <Authorize applicationFunction={ApplicationFunctions.UpdateItemRevision} itemTypeId={formData ? formData.item.itemTypeId : 0}>
                                    <SaveButton  {...getSubmitButtonProps()} />
                                </Authorize>
                            </ButtonBar>
                        </Col>
                        <Col md='3' className='hidden-md'>
                            <ButtonBar offset={0}>
                            </ButtonBar>
                        </Col>
                    </Row>
                </Form.Footer>
            </Form>
            {itemRevisionId && itemId && (
                <Container fluid>
                    <Row>
                        <Col md='12'>
                            <HorizontalTabs
                                id='main-tabs'
                                defaultActiveKey='tab_revisions'
                                tabs={[
                                    {
                                        title: 'Revisions',
                                        eventKey: 'tab_revisions',
                                        component: <ItemRevision_tab_Revisions itemRevision={formData} refreshNr={refreshNr} />
                                    },
                                    {
                                        title: 'Detail item info',
                                        eventKey: 'tab_userdefinedfields',
                                        visible: formData.hasUdf == true,
                                        component: <ItemRevision_tab_UserDefinedFields itemId={itemId} itemRevisionId={itemRevisionId} itemTypeId={formData.item.itemTypeId} refreshNr={refreshNr} />
                                    },
                                    {
                                        title: 'Bill-of-Materials',
                                        eventKey: 'tab_billofmaterials',
                                        visible: formData.item.itemType.hasBom == true,
                                        component: <ItemRevision_tab_BillOfMaterials itemRevision={formData} refreshCounter={0} />,
                                        applicationFunction: ApplicationFunctions.ViewBillOfMaterial,
                                        itemTypeId: formData.item.itemTypeId
                                    },
                                    {
                                        title: 'Attachments',
                                        eventKey: 'tab_attachments',
                                        visible: formData.item.itemType.hasAttachments == true,
                                        component: <ItemRevision_tab_Attachments {...formData} />,
                                        applicationFunction: ApplicationFunctions.ViewAttachment,
                                        attachmentTypeId: 0,
                                        itemTypeId: formData.item.itemTypeId
                                    },
                                    {
                                        title: 'Sub-Items',
                                        eventKey: 'tab_subItems',
                                        visible: formData.item.itemType.createSubItemPerColor == true && formData.item.parentItemId == null,
                                        component: <ItemRevision_tab_SubItems itemRevision={formData} refreshNr={refreshNr} />
                                    },
                                    {
                                        title: 'Workflows',
                                        eventKey: 'tab_workflows',
                                        visible: formData.item.itemType.hasWorkflows == true,
                                        component: <ItemRevision_tab_Workflows itemId={itemId} itemRevisionId={itemRevisionId} itemTypeId={formData.item.itemTypeId} />,
                                        applicationFunction: ApplicationFunctions.ViewWorkflow,
                                        workflowDefinitionId: 0
                                    },
                                    {
                                        title: 'Categories',
                                        eventKey: 'tab_categories',
                                        visible: showCategoryTab,
                                        component: <ItemRevision_tab_ProductCategories itemId={itemId} itemRevisionId={itemRevisionId} itemTypeId={formData.item.itemTypeId} />,
                                    },
                                    {
                                        title: 'Brands',
                                        eventKey: 'tab_brands',
                                        visible: showBrandTab,
                                        component: <ItemRevision_tab_Brands itemId={itemId} itemRevisionId={itemRevisionId} itemTypeId={formData.item.itemTypeId} />,
                                    },
                                    {
                                        title: 'Projects',
                                        eventKey: 'tab_projects',
                                        visible: formData.hasProjects,
                                        component: <ItemRevision_tab_Projects itemId={itemId} itemRevisionId={itemRevisionId} itemTypeId={formData.item.itemTypeId} onProjectMoved={() => setRefreshNr(x => x+1)} />,
                                        applicationFunction: ApplicationFunctions.ViewAllProjects,
                                        projectTypeId: 0
                                    },
                                    {
                                        title: 'Milestones',
                                        eventKey: 'tab_milestones',
                                        visible: formData.milestones.length > 0,
                                        component: <ItemRevision_tab_Milestones itemRevisionId={itemRevisionId} milestones={formData.milestones} />
                                    },
                                    {
                                        title: 'Licenses',
                                        eventKey: 'tab_liceses',
                                        visible: formData.item.itemType.hasLicenses,
                                        component: <ItemRevision_tab_Licenses itemId={itemId} itemRevisionId={itemRevisionId} itemTypeId={formData.item.itemTypeId} />,
                                        applicationFunction: ApplicationFunctions.ViewLicense
                                    },
                                    {
                                        title: 'Business partners',
                                        eventKey: 'tab_businessPartners',
                                        visible: formData.item.itemType.hasBusinessPartners,
                                        component: <ItemRevision_tab_BusinessPartners itemId={itemId} itemRevisionId={itemRevisionId} itemTypeId={formData.item.itemTypeId} refreshNr={refreshNr} />,
                                        applicationFunction: ApplicationFunctions.ViewBusinessPartner
                                    },
                                    {
                                        title: 'Employees',
                                        eventKey: 'tab_employees',
                                        visible: formData.itemEmployees.length > 0,
                                        component: <ItemRevision_tab_Employees itemId={itemId} itemRevisionId={itemRevisionId} itemTypeId={formData.item.itemTypeId} />,
                                        applicationFunction: ApplicationFunctions.ViewEmployee,
                                    },
                                    {
                                        title: 'Prices',
                                        eventKey: 'tab_prices',
                                        visible: formData.item.itemType.hasPrices,
                                        component: <ItemRevision_tab_Prices itemId={itemId} itemRevisionId={itemRevisionId} itemTypeId={formData.item.itemTypeId} />,
                                        applicationFunction: ApplicationFunctions.ViewItemPrice,
                                        itemTypeId: formData.item.itemTypeId
                                    },
                                    {
                                        title: 'History',
                                        eventKey: 'tab_history',
                                        component: <ItemRevision_tab_History itemRevisionId={itemRevisionId} />,
                                        applicationFunction: ApplicationFunctions.ViewItemHistory,
                                        itemTypeId: formData.item.itemTypeId
                                    },
                                ]}
                            />
                        </Col>
                    </Row>
                    {showChangeItemNrPopup && <ItemRevision_popup_ChangeItemNr item={formData.item} show={showChangeItemNrPopup} onHide={() => { setShowChangeItemNrPopup(false); loadFormData(); }} />}
                    {showChangeReferenceCodesPopup && <ItemRevision_popup_ChangeReferenceCodes item={formData.item} show={showChangeReferenceCodesPopup} onHide={() => { setShowChangeReferenceCodesPopup(false); loadFormData(); }} />}
                    {showCreateNewItemRevisionPopup && <ItemRevision_popup_CreateNewItemRevisionPopup itemRevision={formData} show={showCreateNewItemRevisionPopup} onHide={(newItemRevisionId) => { setShowCreateNewItemRevisionPopup(false); navigateTo(newItemRevisionId); }} />}
                    {showCreateNewBomPopup && <ItemRevision_popup_CreateBillOfMaterials itemRevision={formData} show={showCreateNewBomPopup} onHide={() => {  setShowCreateNewBomPopup(false); }} />}
                    {showDeletePopup && <ItemRevision_popup_DeleteItem itemId={itemId} itemRevisionId={itemRevisionId} show={showDeletePopup} onHide={() => { navigate('/plm/home'); setShowDeletePopup(false); }} />}
                    {showDuplicateItemRevisionPopup && <ItemRevision_popup_DuplicateItemRevisionPopup itemRevision={formData} show={showDuplicateItemRevisionPopup} onHide={(newItemRevisionId) => { setShowDuplicateItemRevisionPopup(false); navigateTo(newItemRevisionId);  }} />}
                    {showExportPopup && <ItemRevision_popup_ExportItem itemRevision={formData} show={showExportPopup} onHide={() => { setShowExportPopup(false); }} />}
                    {showGenerateAttachmentPopup && <ItemRevision_popup_GenerateAttachmentPopup itemRevision={formData} show={showGenerateAttachmentPopup} onHide={() => { setShowGenerateAttachmentPopup(false); }} />}
                    {showItemFollowersPopup && <ItemRevision_popup_ItemFollowers item={formData.item} show={showItemFollowersPopup} onHide={() => { setShowItemFollowersPopup(false); }} />}
                    {showStartWorkflowPopup && <ItemRevision_popup_StartWorkflowPopup itemRevision={formData} show={showStartWorkflowPopup} onHide={() => { setShowStartWorkflowPopup(false); }} />}
                    {showUsedInItemsPopup && <ItemRevision_popup_UsedInItemsPopup itemId={itemId} itemRevisionId={itemRevisionId} show={showUsedInItemsPopup} onHide={() => { setShowUsedInItemsPopup(false); }} />}
                    {showItemSizeSetsPopup && <ItemRevision_popup_ItemSizeSets item={formData.item} itemRevisionId={formData.id} show={showItemSizeSetsPopup} onHide={() => setShowItemSizeSetsPopup(false)} />}
                    {showItemSizesPopup && <ItemRevision_popup_ItemSizes item={formData.item} itemRevisionId={formData.id} show={showItemSizesPopup} onHide={() => setShowItemSizesPopup(false)} />}
                    {showItemColorsPopup && <ItemRevision_popup_ItemColors itemRevisionId={formData.id} show={showItemColorsPopup} onHide={() => setShowItemColorsPopup(false)} />}
                    {showEditColorsPopup && <ItemRevision_popup_EditColors show={showEditColorsPopup} onHide={() => { refreshColors(); setShowEditColorsPopup(false) }} onDelete={removeColor} itemColors={formData.colors} />}
                    {showEditSizesPopup && <ItemRevision_popup_EditItemSizes show={showEditSizesPopup} onHide={() => setShowEditSizesPopup(false)} onDelete={removeSize} itemTypeId={formData.item.itemTypeId} itemSizes={formData.itemSizes} />}
                </Container>
            )}
            {showSpinner && <SpinnerOverlay/> }
        </div>
    );
}
export default ItemRevisionView;